export default __webpack_public_path__ + "static/media/01_GabrielOliveira_.9669322f.pdf";